import ColSixCard from "./ColSixCard";

export default ColSixCard;

export { ColSixCard };
